<div #canvasContainer class="canvas-container-{{type}}">
	<canvas #chart></canvas>
</div>
